import React, { useState, useContext } from "react";

import { ToolContext, DONATION_LEVEL_STEP, DONOR_INFO_STEP } from "./ToolProvider";
import Layout from "../Layout";
import * as UI from "./ui";
import DonationLevels from "./DonationLevels";
import WalletOrCardStep from "./WalletOrCardStep";
import Switch from "./Switch"
import ClosedContent from "./ClosedContent";


const InputStep = ({ sweepstakes }) => {
  const { setStep, expired } = useContext(ToolContext);
  const [ errorMessage, setErrorMessage ] = useState('');
  const [ donationLevelError, setDonationLevelError ] = useState('');
  const [ donationInProgress, setDonationInProgress ] = useState(false);

  if(expired) {
    return <ClosedContent sweepstakes={sweepstakes} />
  }

  return (
    <Layout.FullWidth fold>
      <Switch enableDesktopUnfold>
        <DonationLevels
          steps={DONATION_LEVEL_STEP}
          donationLevels={sweepstakes.donationLevels}
          onComplete={() => setStep(DONOR_INFO_STEP)}
          error={donationLevelError}
          disabled={donationInProgress}
        />
        <WalletOrCardStep
          steps={DONOR_INFO_STEP}
          sweepstakes={sweepstakes}
          disabled={donationInProgress}
          setDonationInProgress={setDonationInProgress}
          setErrorMessage={setErrorMessage}
          setDonationLevelError={setDonationLevelError}
        />
      </Switch>
      <Layout.FullWidthColumn>
        { errorMessage && <UI.ErrorMessage>{errorMessage}</UI.ErrorMessage> }
      </Layout.FullWidthColumn>
    </Layout.FullWidth>
  );
};

export default InputStep;
